import { defineComponent as C, reactive as h, computed as r, createBlock as s, openBlock as o, withModifiers as S, normalizeStyle as k, normalizeClass as w, withCtx as B, createElementBlock as F, createCommentVNode as A, renderSlot as I, toDisplayString as x, createElementVNode as T, createVNode as E } from "vue";
import { _ as L } from "./Icon.ce.vue_vue_type_script_setup_true_lang-CdOC0ycX.js";
import { _ as U } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
import { _ as N } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import $ from "./SvgRender.js";
/* empty css                                                                */
import { _ as z } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const H = {
  key: 2,
  class: "tess-avatar__label"
}, M = { class: "tess-avatar__actions" }, R = /* @__PURE__ */ C({
  __name: "Avatar",
  props: {
    label: {
      type: String,
      default: ""
    },
    labelTooltip: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    image: {
      type: [String],
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    isMe: {
      type: Boolean,
      default: !1
    },
    disableHover: {
      type: Boolean,
      default: !1
    },
    bgColor: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    },
    isSubmit: {
      type: Boolean,
      default: !1
    },
    isOpenNewTab: {
      type: Boolean,
      default: !0
    },
    shortLabel: {
      type: String,
      default: ""
    },
    isUseShortLabel: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["removed", "click:on-avatar"],
  setup(c, { emit: m }) {
    const e = c, l = h({
      errorImage: !1
    }), p = r(() => e.image && !l.errorImage), i = m, u = r(() => ({
      "--bg-color-avatar": e.bgColor,
      "--border-color-avatar": d(e.bgColor),
      "--text-color-avatar": e.textColor
    })), f = () => {
      l.errorImage = !0;
    }, n = r(() => {
      if (!e.isUseShortLabel)
        return e.label?.trim();
      if (e.shortLabel)
        return e.shortLabel;
      const t = e.label.split(" ");
      let a = "";
      return t.forEach((y) => {
        a += y.charAt(0).toUpperCase();
      }), a;
    }), d = (t) => {
      t || (t = "transparent");
      let a = "white";
      return (t.toUpperCase() === "#FFFFFF" || t.toUpperCase() === "#FFF" || t.toUpperCase() === "WHITE") && (a = "#A6A6A6"), a;
    }, _ = () => {
      i("removed");
    }, v = r(() => e.icon.startsWith("Custom")), b = r(() => !e.image && e.icon), g = () => {
      e.url && window.open(e.url, e.isOpenNewTab ? "_blank" : "_self"), i("click:on-avatar");
    };
    return (t, a) => (o(), s(N, {
      class: w(["tess-avatar", [{ "disable-hover": e.disableHover, "is-me": e.isMe, "with-custom-icon": v.value, "icon-type": b.value }]]),
      content: e.labelTooltip,
      style: k(u.value),
      onClick: S(g, ["stop"])
    }, {
      default: B(() => [
        p.value ? (o(), s($, {
          key: 0,
          class: "tess-avatar__image",
          url: e.image,
          onError: f
        }, null, 8, ["url"])) : e.icon ? (o(), s(L, {
          key: 1,
          class: "tess-avatar__icon",
          name: e.icon
        }, null, 8, ["name"])) : n.value ? (o(), F("div", H, x(n.value), 1)) : A("", !0),
        I(t.$slots, "actions", {}, () => [
          T("div", M, [
            E(U, {
              class: "tess-avatar__clear-btn",
              "prefix-icon": "Xmark",
              label: "",
              size: "mini",
              onClick: _
            })
          ])
        ], !0)
      ]),
      _: 3
    }, 8, ["content", "class", "style"]));
  }
}), q = /* @__PURE__ */ z(R, [["__scopeId", "data-v-7cb2f315"]]);
export {
  q as default
};
